import { AlertTriangle, CloudRain, Lightbulb, Construction } from 'lucide-react'

export interface UserPOITypeConfig {
  id: string
  name: string
  icon: any
  color: string
  description: string
}

export const USER_POI_TYPES: UserPOITypeConfig[] = [
  {
    id: 'hazard',
    name: 'Hazard',
    icon: AlertTriangle,
    color: '#dc2626', // red-600
    description: 'Report dangers or safety concerns'
  },
  {
    id: 'condition',
    name: 'Condition',
    icon: CloudRain,
    color: '#f97316', // orange-500
    description: 'Report current trail or road conditions'
  },
  {
    id: 'tip',
    name: 'Tip',
    icon: Lightbulb,
    color: '#3b82f6', // blue-500
    description: 'Share helpful advice for other riders'
  },
  {
    id: 'roadworks',
    name: 'Roadworks',
    icon: Construction,
    color: '#f59e0b', // amber-500
    description: 'Report construction or roadworks'
  }
]

export const getUserPOITypeById = (id: string): UserPOITypeConfig | undefined => {
  return USER_POI_TYPES.find(type => type.id === id)
}